import initDataRepository from '@/repositories/init-data-repository'
import HistoryRepository from '@/repositories/history-repository'
import AlertHistoryRepository from '@/repositories/alert-history-repository'
import RainRuiHistoryRepository from '@/repositories/rain-rui-history-repository'
import SummaryRepository from '@/repositories/summary-repository'
import PresentRepository from '@/repositories/present-repository'
import WeatherWarningRepository from '@/repositories/weather-warning-repository'
import WeatherWarningHistoryRepository from '@/repositories/weather-warning-history-repository'
import NewsRepository from '@/repositories/news-repository'
import NotificationsRepository from '@/repositories/notifications-repository'

export default {
  initData: new initDataRepository(),
  history: new HistoryRepository(),
  alertHistory: new AlertHistoryRepository(),
  rainRuiHistory: new RainRuiHistoryRepository(),
  summary: new SummaryRepository(),
  present: new PresentRepository(),
  weatherWarning: new WeatherWarningRepository(),
  weatherWarningHistory: new WeatherWarningHistoryRepository(),
  news: new NewsRepository(),
  notifications: new NotificationsRepository(),
}
